export default "__VITE_ASSET__BShXiKku__"